import { useEffect } from 'react';
import { useLanguage } from './useLanguage';

// The default app name to include with all page titles
const APP_NAME = 'منصة تجمع تبوك الصحي للتعليم والتطوير الصحي';

/**
 * Custom hook to set the page title
 * @param title - The page title to set (without app name)
 * @param includeAppName - Whether to include the app name in the title (default: true)
 */
const usePageTitle = (title: string, includeAppName: boolean = true): void => {
  const { t } = useLanguage();

  useEffect(() => {
    // Translate the title if a translation key is provided
    const translatedTitle = t(title) || title;
    
    // Set the document title with or without the app name
    document.title = includeAppName 
      ? `${translatedTitle} | ${APP_NAME}`
      : translatedTitle;

    // Reset the title when component unmounts
    return () => {
      document.title = APP_NAME;
    };
  }, [title, includeAppName, t]);
};

export default usePageTitle;
